export default __webpack_public_path__ + "static/media/Kanipakam-slider-02@2x.c54b627a.png";